var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempValue),expression:"tempValue"}],staticClass:"text-left form-control",attrs:{"type":"number"},domProps:{"value":(_vm.tempValue)},on:{"input":function($event){if($event.target.composing)return;_vm.tempValue=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }